import { Flex } from 'antd';

import { Navigate, Route, Routes } from '@suntex.core/nav';
import { isAuthenticated, useAuth } from '@suntex.fim/auth/react';

import {
  RankingsSlug,
  getRankingsLandingSlug,
  rankingSections,
} from '../const';

import { RankingsInfo } from './RankingsInfo';
import { RankingsMenu, RankingsMenuProps } from './RankingsMenu';
import { RankingsTable, RankingsTableProps } from './RankingsTable';

export type RankingsProps = Pick<RankingsTableProps, 'searchParams'> &
  RankingsMenuProps;

export function Rankings(props: RankingsProps) {
  const { login } = useAuth(isAuthenticated);
  const landingSlug = getRankingsLandingSlug(login.loginType);
  const menuElement = <RankingsMenu images={props.images} />;
  const indexElement = landingSlug ? (
    <Navigate to={landingSlug} replace />
  ) : (
    menuElement
  );
  return (
    <>
      {/* Header Section */}
      <Flex gap="6px" align="center">
        <h1>
          FIM Rankings <RankingsInfo />
        </h1>
      </Flex>
      <Routes>
        <Route path="" element={indexElement} />
        <Route path="current-ranking" element={indexElement} />
        <Route
          path={RankingsSlug.PlayerIndividualNation}
          element={
            landingSlug ? (
              <RankingsTable
                rankingSlug={RankingsSlug.PlayerIndividualNation}
                searchParams={props.searchParams}
                user={login}
              />
            ) : (
              menuElement
            )
          }
        />
        {rankingSections.flatMap((section) =>
          section.levels.map(({ slug }) => (
            <Route
              key={slug}
              path={slug}
              element={
                <RankingsTable
                  rankingSlug={slug}
                  searchParams={props.searchParams}
                  user={login}
                />
              }
            />
          )),
        )}
      </Routes>
    </>
  );
}
